<template>
    <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            lazy
            transition="scale-transition"
            :position-x="positionX"
            :position-y="positionY"
            absolute
            full-width
            min-width="290px"
    >
        <template v-slot:activator="{on}">
            <v-text-field
                    :value="renderedDates"
                    :label="label"
                    readonly
                    :rules="rules"
                    ref="textField"
                    @mousedown="handleMouseDown"
                    @click="handleClick"
                    @focus.stop="handleFocus"
                    @blur.stop="handleBlur"
                    @keydown.tab="handleTab"
            ></v-text-field>
        </template>
        <v-date-picker
                class="date-range-picker"
                :value="dates"
                multiple
                event-color="light-blue lighten-4 date-in-range"
                @input="onInput"
                :events="dateInRange"
                no-title
                :allowed-dates="allowedDates"
        >
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="handleOK">{{__('general.ok')}}</v-btn>
        </v-date-picker>
    </v-menu>
</template>

<script>
    export default {
        name: "DateRangePicker",
        props: {
            label: String,
            value: {
                type: Array,
                default: () => []
            },
            required: {
                type: Boolean,
                default: true,
            },
            allowedDates: {
                type: Function,
                default: null
            },
        },
        data() {
            return {
                menu: false,
                focused: false,
                mouseDown: false,
                okClicked: false,
                positionX: 0,
                positionY: 0,
                dates: [],
            }
        },
        created() {
            this.dates = _.uniq(this.value);
        },
        mounted() {
            window.addEventListener('resize', this.onResize);
        },
        watch: {
            value(val) {
                this.dates = _.uniq(val);
            },
            menu() {
                this.onResize();
            }
        },
        computed: {
            rules() {
                if (!this.required) {
                    return [];
                }
                return [v => !_.isEmpty(this.dates) || this.__('errors.required')]
            },
            renderedDates() {
                if (!this.dates || _.isEmpty(this.dates)) {
                    return '';
                } else if (this.dates.length === 1) {
                    return this.$moment(this.dates[0]).format('DD.MM.YYYY')
                }
                return this.$moment(this.dates[0]).format('DD.MM.YYYY') + ' - ' + this.$moment(this.dates[1]).format('DD.MM.YYYY')
            }
        },
        methods: {
            dateInRange(date) {
                if (!this.dates || this.dates.length !== 2) {
                    return false;
                }
                return this.$moment(date).isBetween(...this.dates)
            },
            handleMouseDown() {
                if(!this.focused) {
                    this.mouseDown = true;
                }
            },
            handleClick() {
                this.mouseDown = false;
                this.menu=!this.menu;
            },
            handleFocus() {
                this.focused = true;
                if(this.okClicked) {
                    this.okClicked = false;
                }
                else if(!this.mouseDown) {
                    this.menu=true;
                }
            },
            handleBlur() {
                this.focused = false;
                this.mouseDown = false;
            },
            handleTab() {
                this.menu = false;
            },
            handleOK() {
                this.okClicked = true;
                this.$refs.textField.focus();
                this.menu = false;
            },
            onResize() {
                let bounds = this.$refs.textField.$refs.input.getBoundingClientRect();
                this.positionY = bounds.top + bounds.height;
                this.positionX = bounds.left;
            },
            onInput(dates) {
                if (dates.length > 2) {
                    let diff = _.difference(dates, this.dates);
                    this.dates = [diff[0]];
                } else {
                    this.dates = dates;
                }
                this.dates = this.dates.sort();
                this.$emit('input', this.dates);
            },
        }
    }
</script>

<style scoped>

    .date-range-picker >>> .v-btn__content {
        z-index: 1;
    }

    .date-range-picker >>> .v-date-picker-table__events {
        height: 100%;
        width: 100%;
        bottom: 0;
        z-index: 0;
    }

    .date-range-picker >>> .v-date-picker-table__events .date-in-range {
        height: 100%;
        width: 100%;
        bottom: 0;
        z-index: 0;
        margin: 0;
    }
</style>
